/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ManageSystemActionModel {
        public systemActions: Wars.Domain.Model.SystemAction[];
        public currentSystemAction: Wars.Domain.Model.SystemAction;
        
        constructor(
            private systemActionService: services.SystemActionService,
            private deleteService: services.DeleteService,
            systemLevelService: services.SystemLevelService)
        {
            systemLevelService.getSystemLevelSystemActions().then(
                (systemLevel) => {
                    this.systemActions = systemLevel.mySystemActions;
                });
        }

        public addSystemAction(): void {
            var newSystemAction = this.systemActionService.createNewSystemAction();
            newSystemAction.numberOfReturnPaths = 1;
            this.systemActions.push(newSystemAction);
            this.currentSystemAction = newSystemAction;
        }

        public editSystemAction(systemAction: Wars.Domain.Model.SystemAction) {
            this.currentSystemAction = systemAction;
        }

        public removeSystemAction(systemAction: Wars.Domain.Model.SystemAction) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "SystemAction",
                systemAction.id,
                "System Action",
                () => this.systemActions.remove(systemAction));
        }

        public save(): void {
            this.systemActionService.saveAllChanges();
        }

        public close(): void {
            this.currentSystemAction = undefined;
        }
    }
}